/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Pricechart_Selectvalue2Inputs */

const id_components_pricechart_selectvalue2 = /** @type {(inputs: Components_Pricechart_Selectvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih nilai`)
};

const ms_components_pricechart_selectvalue2 = /** @type {(inputs: Components_Pricechart_Selectvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih nilai`)
};

const da_components_pricechart_selectvalue2 = /** @type {(inputs: Components_Pricechart_Selectvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vælg en værdi`)
};

const de_components_pricechart_selectvalue2 = /** @type {(inputs: Components_Pricechart_Selectvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wert auswählen`)
};

const en_us2_components_pricechart_selectvalue2 = /** @type {(inputs: Components_Pricechart_Selectvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a value`)
};

const es_es2_components_pricechart_selectvalue2 = /** @type {(inputs: Components_Pricechart_Selectvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona un valor`)
};

const es_mx2_components_pricechart_selectvalue2 = /** @type {(inputs: Components_Pricechart_Selectvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona un valor`)
};

const fil_components_pricechart_selectvalue2 = /** @type {(inputs: Components_Pricechart_Selectvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pumili ng halaga`)
};

const fr_components_pricechart_selectvalue2 = /** @type {(inputs: Components_Pricechart_Selectvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner une valeur`)
};

const it_components_pricechart_selectvalue2 = /** @type {(inputs: Components_Pricechart_Selectvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un valore`)
};

const hu_components_pricechart_selectvalue2 = /** @type {(inputs: Components_Pricechart_Selectvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Válassz értéket`)
};

const nl_components_pricechart_selectvalue2 = /** @type {(inputs: Components_Pricechart_Selectvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecteer een waarde`)
};

const no_components_pricechart_selectvalue2 = /** @type {(inputs: Components_Pricechart_Selectvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velg en verdi`)
};

const pl_components_pricechart_selectvalue2 = /** @type {(inputs: Components_Pricechart_Selectvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz wartość`)
};

const pt_br2_components_pricechart_selectvalue2 = /** @type {(inputs: Components_Pricechart_Selectvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a value`)
};

const pt_components_pricechart_selectvalue2 = /** @type {(inputs: Components_Pricechart_Selectvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecionar um valor`)
};

const ro_components_pricechart_selectvalue2 = /** @type {(inputs: Components_Pricechart_Selectvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectează o valoare`)
};

const fi_components_pricechart_selectvalue2 = /** @type {(inputs: Components_Pricechart_Selectvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valitse arvo`)
};

const sv_components_pricechart_selectvalue2 = /** @type {(inputs: Components_Pricechart_Selectvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Välj ett värde`)
};

const vi_components_pricechart_selectvalue2 = /** @type {(inputs: Components_Pricechart_Selectvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn một giá trị`)
};

const tr_components_pricechart_selectvalue2 = /** @type {(inputs: Components_Pricechart_Selectvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir değer seçin`)
};

const cs_components_pricechart_selectvalue2 = /** @type {(inputs: Components_Pricechart_Selectvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte hodnotu`)
};

const bg_components_pricechart_selectvalue2 = /** @type {(inputs: Components_Pricechart_Selectvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изберете стойност`)
};

const ru_components_pricechart_selectvalue2 = /** @type {(inputs: Components_Pricechart_Selectvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите значение`)
};

const uk_components_pricechart_selectvalue2 = /** @type {(inputs: Components_Pricechart_Selectvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Виберіть значення`)
};

const ar_components_pricechart_selectvalue2 = /** @type {(inputs: Components_Pricechart_Selectvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اختر قيمة`)
};

const hi_components_pricechart_selectvalue2 = /** @type {(inputs: Components_Pricechart_Selectvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक मान चुनें`)
};

const th_components_pricechart_selectvalue2 = /** @type {(inputs: Components_Pricechart_Selectvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เลือกค่า`)
};

const ja_components_pricechart_selectvalue2 = /** @type {(inputs: Components_Pricechart_Selectvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`値を選択`)
};

const zh_cn2_components_pricechart_selectvalue2 = /** @type {(inputs: Components_Pricechart_Selectvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a value`)
};

const zh_hant1_components_pricechart_selectvalue2 = /** @type {(inputs: Components_Pricechart_Selectvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a value`)
};

const ko_components_pricechart_selectvalue2 = /** @type {(inputs: Components_Pricechart_Selectvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a value`)
};

/**
* | output |
* | --- |
* | "Select a value" |
*
* @param {Components_Pricechart_Selectvalue2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_pricechart_selectvalue2 = /** @type {((inputs?: Components_Pricechart_Selectvalue2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Pricechart_Selectvalue2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_pricechart_selectvalue2(inputs)
	if (locale === "ms") return ms_components_pricechart_selectvalue2(inputs)
	if (locale === "da") return da_components_pricechart_selectvalue2(inputs)
	if (locale === "de") return de_components_pricechart_selectvalue2(inputs)
	if (locale === "en-US") return en_us2_components_pricechart_selectvalue2(inputs)
	if (locale === "es-ES") return es_es2_components_pricechart_selectvalue2(inputs)
	if (locale === "es-MX") return es_mx2_components_pricechart_selectvalue2(inputs)
	if (locale === "fil") return fil_components_pricechart_selectvalue2(inputs)
	if (locale === "fr") return fr_components_pricechart_selectvalue2(inputs)
	if (locale === "it") return it_components_pricechart_selectvalue2(inputs)
	if (locale === "hu") return hu_components_pricechart_selectvalue2(inputs)
	if (locale === "nl") return nl_components_pricechart_selectvalue2(inputs)
	if (locale === "no") return no_components_pricechart_selectvalue2(inputs)
	if (locale === "pl") return pl_components_pricechart_selectvalue2(inputs)
	if (locale === "pt-BR") return pt_br2_components_pricechart_selectvalue2(inputs)
	if (locale === "pt") return pt_components_pricechart_selectvalue2(inputs)
	if (locale === "ro") return ro_components_pricechart_selectvalue2(inputs)
	if (locale === "fi") return fi_components_pricechart_selectvalue2(inputs)
	if (locale === "sv") return sv_components_pricechart_selectvalue2(inputs)
	if (locale === "vi") return vi_components_pricechart_selectvalue2(inputs)
	if (locale === "tr") return tr_components_pricechart_selectvalue2(inputs)
	if (locale === "cs") return cs_components_pricechart_selectvalue2(inputs)
	if (locale === "bg") return bg_components_pricechart_selectvalue2(inputs)
	if (locale === "ru") return ru_components_pricechart_selectvalue2(inputs)
	if (locale === "uk") return uk_components_pricechart_selectvalue2(inputs)
	if (locale === "ar") return ar_components_pricechart_selectvalue2(inputs)
	if (locale === "hi") return hi_components_pricechart_selectvalue2(inputs)
	if (locale === "th") return th_components_pricechart_selectvalue2(inputs)
	if (locale === "ja") return ja_components_pricechart_selectvalue2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_pricechart_selectvalue2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_pricechart_selectvalue2(inputs)
	return ko_components_pricechart_selectvalue2(inputs)
});
export { components_pricechart_selectvalue2 as "components.priceChart.selectValue" }